<template>
  <router-view />
</template>
<style>
.cssrender {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  pointer-events: none;
}
</style>